<div class="header">
  <div class="flex alignCenter colgap10">
    <img src="../assets/noise.png" alt="" height="50px" width="50px" />
    <div class="logo">
      <h3>
        {{ 'title' | translator }}
      </h3>
    </div>
  </div>
  <div class="flex alignCenter hoverable" *ngIf="commonService.role">
    <a matRipple [matRippleDisabled]="true" class="hdrBtn" routerLink="home" routerLinkActive="active">Home</a>
    <a
      matRipple
      [matRippleDisabled]="true"
      class="hdrBtn"
      routerLink="usermgmt"
      routerLinkActive="active"
      *ngIf="commonService.role === 'superadmin'"
      >User Management</a
    >
    <a
      matRipple
      [matRippleDisabled]="true"
      class="hdrBtn"
      routerLink="useractivity"
      routerLinkActive="active"
      *ngIf="commonService.role === 'superadmin'"
      >User Activity</a
    >
    <a
      matRipple
      [matRippleDisabled]="true"
      class="hdrBtn"
      routerLink="oddactivity"
      routerLinkActive="active"
      *ngIf="commonService.role === 'superadmin'"
      >Unusual Activity</a
    >
    <a
      matRipple
      [matRippleDisabled]="true"
      class="hdrBtn"
      routerLink="log-analyzer"
      routerLinkActive="active"
      *ngIf="commonService.role === 'superadmin'"
      >Log Analyzer</a
    >
  </div>
  <div class="flex alignCenter colgap10">
    <div class="flex alignCenter" [matMenuTriggerFor]="menu">
      <div class="mt5">
        <mat-icon height="50px" width="50px">account_circle</mat-icon>
      </div>
      <div class="hoverable">
        {{ this.commonService.username }} <span *ngIf="this.commonService.role">({{ this.commonService.role }})</span>
      </div>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="changeRole()">Change role</button>
      </mat-menu>
    </div>
    <div>
      <button mat-flat-button (click)="commonService.logOut()">Sign out</button>
    </div>
  </div>
</div>

<ng-template #userRoles let-data>
  <textarea #reason rows="12" cols="46" [formControl]="commonService.reason" maxlength="250"></textarea>
  <p class="flex end hint">{{ commonService.reason.value.length }}/250</p>
  <div class="flex col row-gap10">
    <label>Roles</label>
    <mat-form-field appearance="outline">
      <mat-select [formControl]="commonService.userRole" (selectionChange)="changeUserRole($event)">
        <mat-option *ngFor="let role of roles" [value]="role">
          {{ role }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
